// Shows "Neue Version geladen" once after the reload that activated a new service worker.
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "@/components/ui/Toast";
import { consumeUpdatedFlag } from "./update-state";

export function PwaUpdateToast() {
  const { t } = useTranslation("translation", { keyPrefix: "pwa" });
  const toast = useToast();
  useEffect(() => {
    if (consumeUpdatedFlag()) toast({ tone: "info", title: t("update.title") });
  }, [toast, t]);
  return null;
}
